import { useMemo } from 'react';
import { useAsyncTaskAxios, useAsyncRun } from 'react-hooks-async';
import { useApplicationEnv } from 'application.env/react';
import axios, { AxiosResponse } from 'axios';
import { AssessmentMark } from '@cambridgeassessment/checkpoint-dtos';

export interface AssessmentMarksWithHold {
  outdatedHolds: boolean;
  assessmentMarks: AssessmentMark[];
}

export interface LearnerStatsProps {
  sessionId: number;
  qualificationId: number;
  centreId: string;
  refreshMarks: boolean;
}

export interface LearnerStatsData {
  retrievingLearnerStats: boolean;
  errorRetrievingLearnerStats: Error | null;
  assessmentMarks: AssessmentMark[];
  outdatedHolds: boolean;
}

export const useLearnerStats = (sesQualProps: LearnerStatsProps): LearnerStatsData => {
  const config = useApplicationEnv();

  const { sessionId, qualificationId, centreId, refreshMarks } = sesQualProps;

  const getLearnerStatsMemo = useMemo(() => {
    if (!config) {
      return undefined;
    }
    return {
      url: `${config.API_DOMAIN}/sessions/${sessionId}/qualifications/${qualificationId}/centres/${centreId}`,
    };
  }, [config]);

  const getLearnerStatsTask = useAsyncTaskAxios<AxiosResponse<AssessmentMarksWithHold>>(
    axios,
    getLearnerStatsMemo
  );

  useAsyncRun(config && refreshMarks && getLearnerStatsTask);

  return {
    retrievingLearnerStats: getLearnerStatsTask.started && getLearnerStatsTask.pending,
    errorRetrievingLearnerStats: getLearnerStatsTask.error,
    assessmentMarks: getLearnerStatsTask?.result?.data.assessmentMarks || [],
    outdatedHolds: getLearnerStatsTask?.result?.data.outdatedHolds || false,
  };
};
